import { lazy } from 'react';

const Profile = lazy(() => import('./MerchantProfilePage'));

const MerchantProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/merchant/profile',
      element: <Profile />,
    },
  ],
};

export default MerchantProfileConfig;
